import React from "react";

import {
  Button,
  Card,
  CardContent,
  Dialog,
  DialogTitle,
  DialogTitleActions,
  Type,
  List
} from "discover.medical.react-component-library";
import "./index.css";

const MessageDialog = ({ isDialogOpen }) => {
  const [isOpen, setIsOpen] = React.useState(false);

  const closeModal = () => {
    setIsOpen(false);
  };

  React.useEffect(() => {
    setTimeout(() => {
      setIsOpen(isDialogOpen);
    }, 500);
  }, [isDialogOpen]);

  return (
    <>
      <Dialog
        aria-labelledby="text-dialog-title"
        isOpen={isOpen}
        maxWidth="md"
        onRequestClose={closeModal} 
        className="MessageDialog_dialog">
        <DialogTitle className="MessageDialog_dialogTitle">
          <h3> </h3>
          <DialogTitleActions justify="left" onRequestClose={closeModal} className="MessageDialog_dialogTitleAction"/>
        </DialogTitle>
        <Card className="MessageDialog_card">
            <CardContent className="MessageDialog_dialogHeaderText">
                <Type fontSize="xl" fontFamily="base">
                    To get seamless access from your EHR, please 
                    <Type fontSize="xl" fontFamily="base" element="strong"> create or sign in to a personal user account. </Type>
                    <Type fontSize="xl" element="i" fontFamily="base"> (You only need to do this once.)</Type> 
                </Type>
                <Type fontSize="md" fontFamily="base" className="MessageDialog_dialogCenterText">
                    <Type className="MessageDialog_dialogCenterText">You'll also get*:</Type>
                    <List type="ul" columns={1}>
                        <Type lineHeight="icon" className="MessageDialog_listItem">
                            <List.Item> Bookmarking and following of specialties/topics </List.Item>
                        </Type>
                        <Type lineHeight="icon" className="MessageDialog_listItem">
                            <List.Item>Earning and claiming CME/CE</List.Item>
                        </Type>
                        <Type lineHeight="icon" className="MessageDialog_listItem">
                            <List.Item>Access to mobile apps</List.Item>
                        </Type>
                    </List>
                </Type>
                <Type className="MessageDialog_dialogFooterText" fontSize="xs" element="i">* Some features listed are not available in all EBSCO Clinical Decisions products</Type>
                <div className="MessageDialog_dialogActionContainer">
                    <Button className="MessageDialog_dialogActionButton" variant="primary" onClick={closeModal}>
                        Okay
                    </Button>
                </div>
          </CardContent>
        </Card>
      </Dialog>
    </>
  );
};

export default MessageDialog;